'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getHandleStyle = function getHandleStyle(_ref) {
    var _ref$pos = _ref.pos,
        x = _ref$pos.x,
        y = _ref$pos.y;
    return {
        left: x,
        top: y
    };
};

var DragHandle = function DragHandle(props) {
    var show = props.show,
        className = props.className,
        style = props.style,
        connectDragSource = props.connectDragSource,
        isHitArea = props.isHitArea,
        snapped = props.snapped,
        onMouseDown = props.onMouseDown,
        onDoubleClick = props.onDoubleClick;

    if (!show) return null;

    var handleStyles = _extends({}, getHandleStyle(props), style);

    var wrapperFn = connectDragSource || _lodash.identity;
    return wrapperFn(_react2.default.createElement('div', { className: (0, _classnames2.default)('DragHandle', className, { 'hit-area': isHitArea, snapped: snapped }),
        onMouseDown: onMouseDown, onDoubleClick: onDoubleClick,
        style: handleStyles }));
};

DragHandle.propTypes = {
    show: _propTypes2.default.bool,
    pos: _propTypes2.default.object,
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    isHitArea: _propTypes2.default.bool,
    onMouseDown: _propTypes2.default.func,
    snapped: _propTypes2.default.bool
};

exports.default = DragHandle;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/DragHandle.js
// module id = 734
// module chunks = 0